var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProjectDetails',{attrs:{"hide-adding-new-row":"","hide-compare-views":"","hide-documents":"","hide-find-in-view":"","hide-remove-project":"","hide-shared-link":"","hide-summary-comments":"","hide-versions":"","is-shared-link":""}})}
var staticRenderFns = []

export { render, staticRenderFns }